import React from "react";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import Button from "reactstrap/lib/Button";
import FormGroup from "reactstrap/lib/FormGroup";
import Label from "reactstrap/lib/Label";
import Select from "react-select";
import { FormattedMessage } from "react-intl";
import axios from "../../services/api/api";
import { toast } from "react-toastify";

const CreateOrUpdateAdminUserForm = ({
  values,
  errors,
  touched,
  isSubmitting,
  dismissModal,
}) => {
  const currentRole = values.roles.find((e) => e.label === values.role)
    ? values.roles.find((e) => e.label === values.role)
    : values.roles[0];

  const handleChange = (value) => {
    values.role = value;
  };

  return (
    <div>
      <Form>
        <FormGroup>
          <Label>Namn</Label>
          <Field
            className={`form-control ${
              errors.name && touched.name && "is-invalid"
            }`}
            type="input"
            name="name"
            placeholder="Användarens namn"
          />
          {errors.name && touched.name && (
            <div className="invalid-feedback">{errors.name}</div>
          )}
        </FormGroup>
        <FormGroup>
          <Label>E-postadress</Label>
          <Field
            className={`form-control ${
              errors.email && touched.email && "is-invalid"
            }`}
            type="email"
            name="email"
            placeholder="Användarens e-postadress"
          />
          {errors.email && touched.email && (
            <div className="invalid-feedback">{errors.email}</div>
          )}
        </FormGroup>
        <FormGroup>
          <Select
            placeholder="Välj roll..."
            className={`${
              errors.selectedTeacherIds &&
              touched.selectedTeacherIds &&
              "is-invalid"
            }`}
            onChange={(selected) => handleChange(selected)}
            defaultValue={currentRole}
            options={values.roles}
          />
        </FormGroup>

        <FormGroup>
          <Label>Access token</Label>
          <Field
            className={`form-control ${
              errors.token && touched.token && "is-invalid"
            }`}
            type="input"
            name="token"
            placeholder="Access token"
          />
          {errors.token && touched.token && (
            <div className="invalid-feedback">{errors.token}</div>
          )}
        </FormGroup>

        <div div className="d-flex justify-content-end gap-2">
          <Button color="secondary" outline onClick={dismissModal}>
            <FormattedMessage id="Cancel" />
          </Button>
          <Button color="primary" outline type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Sparar..." : "Spara"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

const FormikForm = withFormik({
  mapPropsToValues({ user }) {
    return {
      updateUser: user !== null,
      name: user ? user.name : "",
      email: user ? user.email : "",
      token: "",
      roles: [
        { label: "Admin", value: 3 },
        { label: "SuperUser", value: 2 },
      ],
      role: user ? user.role : null,
    };
  },

  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email(
        <FormattedMessage id="Views.Teacher.CreateAdminUser.Form.Error.EmailFormat" />
      )
      .required(
        <FormattedMessage id="Views.Teacher.CreateAdminUser.Form.Error.RequireEmail" />
      ),
    name: Yup.string().required(
      <FormattedMessage id="Views.Teacher.CreateAdminUser.Form.Error.RequireName" />
    ),
    token: Yup.string().required(
      <FormattedMessage id="Views.Teacher.CreateAdminUser.Form.Error.RequireToken" />
    ),
  }),

  handleSubmit(values, { props, resetForm, setErrors, setSubmitting }) {
    var user = {
      name: values.name,
      email: values.email,
      validationToken: values.token,
    };

    if (values.role) {
      user.role = values.role.label ? values.role.label : values.role;
    } else if (props.updateUser) {
      user.role = props.user.role;
    } else {
      user.role = "Admin";
    }

    if (values.updateUser) {
      user.id = props.user.id;
      this.updateUser(user, props, resetForm, setErrors, setSubmitting);
    } else {
      this.createNewUser(user, props, resetForm, setErrors, setSubmitting);
    }
    setSubmitting(false);
  },

  createNewUser(user, props, resetForm, setErrors, setSubmitting) {
    axios
      .post("/user/createuser", user)
      .then((res) => {
        toast.success("Användaren har lagts till");
        setSubmitting(false);
        props.dismissModal();
      })
      .catch((err) => {
        toast.warn(`Det gick inte att lägga till användaren: ${err}`);
        setSubmitting(false);
      });
  },

  updateUser(user, resetForm, setErrors, setSubmitting) {
    console.warn("updateUser() => NOT IMPLEMENTED");
  },
})(CreateOrUpdateAdminUserForm);

export default FormikForm;
